module.exports = __webpack_public_path__ + "media/images/icons/email-dark-d4c9589f61bc2bc6d0ee702932fc5dd6.png";